import React, { useState, useEffect } from "react";
import OrderForm from "../Forms/OrderForm";
import useCartStore from "../../stores/useCartStore";
import CartItem from "./cartItem";
import { useNavigate } from "react-router-dom";
import { GetTeacherInformation } from "../../actions/teacherQueries";

export default function ConfirmedOrder() {
  const navigate = useNavigate();
  const [totalPrice, setTotalPrice] = useState(0);

  const result = useCartStore((state) => state.result);
  const clearCart = useCartStore((state) => state.clearCart);
  const teacherInfo = GetTeacherInformation();

  useEffect(() => {
    setTotalPrice(0);
    result.forEach((order) => {
      setTotalPrice(
        (prevstate) =>
          prevstate + order.priceStudent * order.addedStudents.length
      );
    });
  }, [result]);

  const cleanCartAfterPurchase = () => {
    clearCart();
  };

  const cartList = () => {
    return result.map((cartItem, i) => {
      if (cartItem.addedStudents.length > 0) {
        return (
          <CartItem
            key={i}
            readonly={true}
            cartItem={cartItem}
            onAddUnit={null}
            onDeductUnit={null}
            handleDeleteFromCart={null}
          />
        );
      } else {
        return null;
      }
    });
  };

  if (teacherInfo.isPending) return null;

  return (
    <>
      <OrderForm
        navigate={navigate}
        cartList={cartList}
        cart={{ result }}
        totalPrice={totalPrice}
        teacherInformation={teacherInfo.data}
        cleanCartAfterPurchase={() => cleanCartAfterPurchase()}
      />
    </>
  );
}
